/** Persist menu items-per-page for the Elvix storefront. */

export const MENU_PAGE_SIZE_STORAGE_KEY = 'elvix.menu.pageSize';
export const DEFAULT_MENU_PAGE_SIZE = 28;
export const MENU_PAGE_SIZE_OPTIONS = [14, 28,63,112];

export function readMenuPageSize(fallback = DEFAULT_MENU_PAGE_SIZE) {
    const fallbackSize =
        Number.isInteger(fallback) && fallback > 0 ? fallback : DEFAULT_MENU_PAGE_SIZE;
    try {
        const raw = localStorage.getItem(MENU_PAGE_SIZE_STORAGE_KEY);
        if (raw == null || raw === '') return fallbackSize;
        const size = Number.parseInt(raw, 10);
        if (!MENU_PAGE_SIZE_OPTIONS.includes(size)) return fallbackSize;
        return size;
    } catch {
        return fallbackSize;
    }
}

export function writeMenuPageSize(size) {
    try {
        const next = Number.parseInt(String(size), 10);
        if (!MENU_PAGE_SIZE_OPTIONS.includes(next)) return;
        localStorage.setItem(MENU_PAGE_SIZE_STORAGE_KEY, String(next));
    } catch {
        // Ignore quota / private-mode failures.
    }
}
